module.exports = __webpack_public_path__ + "static/media/ceremonie.b9266643.jpg";